// constants/subscriptionConstants.js

export const MODULE_CATEGORIES = {
  'Core': ['dashboard', 'settings', 'userManagement'],
  'Student Management': ['studentManagement', 'admissions', 'enrollment', 'studentProfiles'],
  'Staff Management': ['staffManagement', 'facultyManagement', 'hrManagement'],
  'Academic': ['academicManagement', 'classManagement', 'timetable', 'subjects', 'grades'],
  'Attendance': ['classliveview', 'staffAttendance', 'studentAttendance'],
  'Examinations': ['websiteManagement', 'examScheduling', 'results', 'reportCards'],
  'Fees': ['feeManagement', 'feeStructure', 'feeCollection', 'invoices', 'receipts'],
  'Transport': ['transport', 'busRoutes', 'vehicleTracking', 'transportFees'],
  'Hostel': ['hostel', 'hostelManagement', 'roomAllocation', 'hostelFees'],
  'Library': ['library', 'lmsmanagement', 'circulation', 'digitalLibrary'],
  'Communication': ['communication', 'emailNotifications', 'smsNotifications', 'parentPortal'],
  'Finance': ['finance', 'accounting', 'expenses', 'budgeting'],
  'Reports': ['reports', 'analytics', 'customReports'],
  'Additional': ['bulkUpload', 'dataExport', 'dataImport', 'apiAccess', 'webhooks', 'mobileApp']
};

export const ROLES_LIST = [
  'Controller of Examination',
  'COE Coordinator',
  'Faculty',
  'Principal',
  'HOD',
  'Head of Institution',
  'Librarian',
  'Head Guard',
  'Guard',
  'Student',
  'Parent',
  'Accountant'
];

export const STATUS_STYLES = {
  active: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  trial: 'bg-blue-50 text-blue-700 border-blue-200',
  expired: 'bg-rose-50 text-rose-700 border-rose-200',
  cancelled: 'bg-slate-50 text-slate-700 border-slate-200',
  suspended: 'bg-red-50 text-red-700 border-red-200',
  none: 'bg-slate-100 text-slate-500 border-slate-200'
};

export const STATUS_ICONS = {
  active: 'Check',
  trial: 'Gift',
  expired: 'X',
  cancelled: 'Ban',
  suspended: 'AlertCircle'
};